module.exports = __webpack_public_path__ + "static/media/warning_delete.1140a631.svg";